function Mapper () {
  function categories (data) {
    return data.map(category => {
      return {
        id: category.id_token,
        name: category.category_name,
        slug: category.category_slug,
        subCategories: category.sub_categories.map(item => {
          return {
            id: item.id_token,
            name: item.category_name,
            slug: item.category_slug,
            subCategories: item.sub_categories.map(item2 => {
              return {
                id: item2.id_token,
                name: item2.category_name,
                slug: item2.category_slug
              }
            })
          }
        })
      }
    })
  }

  return {
    categories
  }
}

export default Mapper()